import axois from "axios";
import { getCurrentLogedUserData } from ".";

import * as actionTypes from "./actionTypes";

export const initBecomeFeature = () => {
  return {
    type: actionTypes.INIT_BECOME_FEATURE_DEALER,
    becoming: true,
  };
};

export const successBecomeFeature = (status) => {
  return {
    type: actionTypes.SUCCESS_BECOME_FEATURE_DEALER,
    becoming: false,
    amFeatured: status,
  };
};

export const failBecomeFeature = (error) => {
  return {
    type: actionTypes.FAIL_BECOME_FEATURE_DEALER,
    becoming: false,
    error: error,
  };
};

export const becomeFeatureDealer = (validity) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  const data = {
    validity: validity,
  };
  return (dispatch) => {
    dispatch(initBecomeFeature());
    axois
      .post("users/me/set_as_featured_dealer", data, config)
      .then((response) => {
        dispatch(successBecomeFeature(true));
        dispatch(getCurrentLogedUserData(localStorage.getItem("idToken")));
      })
      .catch((error) => {
        dispatch(failBecomeFeature("You don't have enough Token."));
      });
  };
};
